function pagination() {
    const nav = document.querySelector('[data-pagination]');
    if (!nav) return;

    const current = parseInt(nav.dataset.page, 10);
    const total = parseInt(nav.dataset.pages, 10);
    const container = nav.querySelector('[data-pagination-pages]');
    if (!current || !total || !container) return;

    let base = nav.dataset.base || '/';
    if (!base.endsWith('/')) base += '/';

    const pageUrl = function (number) {
        return number === 1 ? base : `${base}page/${number}/`;
    };

    // First two, last two, and the current page with one neighbour either side, e.g. 1 2 3 … 9 10
    const numbers = new Set([1, 2, total - 1, total]);
    for (let i = current - 1; i <= current + 1; i++) {
        if (i >= 1 && i <= total) numbers.add(i);
    }
    if (current <= 3) numbers.add(2).add(3);
    if (current >= total - 2) numbers.add(total - 1).add(total - 2);

    const sorted = Array.from(numbers).filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
    const fragment = document.createDocumentFragment();
    let previous = 0;

    sorted.forEach(function (number) {
        if (number - previous > 1) {
            const gap = document.createElement('span');
            gap.className = 'gh-pagination-page is-gap';
            gap.textContent = '…';
            fragment.appendChild(gap);
        }

        let item;
        if (number === current) {
            item = document.createElement('span');
            item.className = 'gh-pagination-page is-current';
            item.setAttribute('aria-current', 'page');
        } else {
            item = document.createElement('a');
            item.className = 'gh-pagination-page';
            item.href = pageUrl(number);
        }
        item.textContent = number;
        fragment.appendChild(item);
        previous = number;
    });

    container.replaceChildren(fragment);
}
